import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Cloudinary } from 'services/cloudinary';

@Component({
    selector: 'xm-single-image-modal',
    templateUrl: 'single.html',
    styleUrls: [ 'single.scss' ]
})

export class SingleImageModal implements OnInit {
    public data: SingleImageModalData;
    public imageOptions: MediaImageOptions;
    public iconOptions: MediaImageOptions[];

    private dialogRef: MatDialogRef<SingleImageModal>;

    constructor(dialogRef: MatDialogRef<SingleImageModal>, @Inject(MAT_DIALOG_DATA) data: SingleImageModalData) {
        Object.assign(this, { data, dialogRef });
    }

    public ngOnInit(): void {
        this.imageOptions = {
            mobile: Cloudinary.generateMediaFromCms(this.data.headerIcon)
        };

        this.data.content.forEach((content: SingleImageModalContent) => {
            if (content.icon) {
                content.iconOptions = {
                    mobile: Cloudinary.generateMediaFromCms(content.icon)
                };
            }
        });
    }

    public close(action: string): void {
        const response: ModalResponse = {
            close: action === 'close',
            primary: action === 'primary',
            secondary: action === 'secondary'
        };

        this.dialogRef.close(response);
    }
}
